import React, { useState, useEffect, Fragment } from 'react';
import Modal from '@material-ui/core/Modal';
import { Col, Row, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import AlertModal from '../../../../shared/components/Modal';

const ModalUpdatePricesAdmision = ({ service, idAdmision, opened, closeModal, callbackReceiptAdmision }) => {

    const [priceService, setPriceService] = useState(null);

    const [colorAlertModal, setColorAlertModal] = useState(null);
    const [messagAlerteModal, setMessagAlerteModal] = useState(null);
    const [showAlertModal, setShowAlertModal] = useState(false);

    //Articulos
    useEffect(() => {
        if (service != null) {
            setPriceService(service.costo);
        }
    }, []);

    const confirmPrice = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/cambiar-valores-servicios', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_admision: idAdmision,
                id_servicio: service != null ? service.id_servicio : null,
                costo_nuevo: priceService
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403 && response.status != 404) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(res => {
            console.log(res);
            setMessagAlerteModal("Costo modificado exitosamente");
            setColorAlertModal("success");
            setShowAlertModal(true);
        }).catch((error) => {
            setMessagAlerteModal("Ha ocurrido un error en el Servidor");
            setColorAlertModal("danger");
            setShowAlertModal(true);
            console.error('Error:', error);
        });
    }

    const onOkModal = () => {
        switch (colorAlertModal) {
            case "success":
                setShowAlertModal(false);
                setMessagAlerteModal("");
                setColorAlertModal("");
                callbackReceiptAdmision();
                closeModal();
                break;
            case "warning":
                setShowAlertModal(false);
                setMessagAlerteModal("");
                setColorAlertModal("");
                break;
            case "danger":
                setShowAlertModal(false);
                setMessagAlerteModal("");
                setColorAlertModal("");
                break;
        }
    }

    const onToggleModal = () => {
        switch (colorAlertModal) {
            case "success":
                setShowAlertModal(false);
                setMessagAlerteModal("");
                setColorAlertModal("");
                callbackReceiptAdmision();
                closeModal();
                break;
            case "warning":
                setShowAlertModal(false);
                setMessagAlerteModal("");
                setColorAlertModal("");
                break;
            case "danger":
                setShowAlertModal(false);
                setMessagAlerteModal("");
                setColorAlertModal("");
                break;
        }
    }

    return (
        <Fragment>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
                disableEnforceFocus={true}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Actualizar Precios</h5>
                        </div>

                        <Row>
                            <Col md={6}>
                                <TextField
                                    key={`serviceName`}
                                    name={`serviceName`}
                                    id="serviceName"
                                    style={{ margin: 10, width: '100%' }}
                                    label="Servicio"
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: true
                                    }}
                                    value={service != null && service != undefined ? service.nombre : ""}
                                    onChange={(e) => { this.setState({ typeDocument: e.target.value }) }}
                                    disabled={true}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    key={`priceService`}
                                    name={`priceService`}
                                    id="priceService"
                                    type="number"
                                    style={{ margin: 10, width: '100%' }}
                                    label="Costo del Servicio"
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: true
                                    }}
                                    placeholder={"Costo del Servicio"}
                                    value={priceService}
                                    onChange={(e) => {
                                        setPriceService(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                confirmPrice();
                            }}
                        >
                            Confirmar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => {
                    onOkModal();
                }}
                toggle={() => {
                    onToggleModal();
                }}
            />

        </Fragment>
    );
};
export default ModalUpdatePricesAdmision;
